import { Component } from "@angular/core";

@Component({
  selector: "user-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {}
